<template>
  <div class="floor-service">
    <div class="container">
      <ul class="clearfix">
        <li class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/1_03.png'">
          <span class="grid-text">专业</span>
        </li>
        <li class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/1_05.png'">
          <span class="grid-text">安全</span>
        </li>
        <li class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/1_07.png'">
          <span class="grid-text">高价</span>
        </li>
        <li class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/1_09.png'">
          <span class="grid-text">便捷</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  }
};
</script>

<style scoped>
.floor-service {
  margin-bottom: -40px;
  background-color: #fabe00;
}

.grid {
  float: left;
  width: 25%;
  line-height: 46px;
  text-align: center;
}

.grid-icon {
  width: 46px;
  height: 46px;
  margin: 17px 0;
  vertical-align: middle;
}

.grid-text {
  margin-left: 16px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-service.vue